import EnumService from '../EnumService'

export default class TipoFluxoBancarioEnumService extends EnumService{

    constructor(){
        super('enumMovBancaria');
    }
  
  }